export enum PersonalPayments {
	CashAdvance = 0,
	Other = 1,
}
